import axios from 'axios';
import moment from 'moment';
// export function getVendorSite (orgId, _this, callBack = null) {
//     axios.post('/gscapp/erpQuery/getvendorSiteByOrgId', {
//         pageSize: 99,
//         pageIndex: 1,
//         countStatus: 'N',
//         orgId,
//         vendorId: _this.vendorId
//     })
//     .then((res) => {
//         let data = res.data.data;
//         callBack && callBack(data.list || []);
//     });
// }

export function getOuList (callBack) {
    return axios.get('/gscint/vendor/getOULovNew2', {
        params: {
            labelName: 'ouName',
            valueName: 'erpOuId',
            vendorSiteActive: 'Y'
        }
    })
    .then((res) => {
        callBack && callBack(res.data.data);
    });
}

// export function queryLineTrcs (_this, headerId, itemCode, type = 'new', moduleName = 'detailModule') {
//     return axios.post(`/gscint/hw/invacc/${type === 'new' ? 'queryTransactions' : 'queryLines'}`, {
//         headerId,
//         ..._this.invaccHeader,
//         vendorCode: _this.vendorCode,
//         itemCode,
//         pageNum: _this[moduleName].settings.currentPage,
//         pageSize: _this[moduleName].settings.pageSize,
//     })
//     .then((res) => {
//         let {list, total} = res.data.data;
//         _this[moduleName].tableData = list;
//         _this[moduleName].settings.total = total;
//     });
// }

export function queryList (url, data, _this) {
    return new Promise((resolve, reject) => {
        axios.post(url, {
            ...data
        })
        .then((res) => {
            let {list, total} = res.data.data;
            resolve({
                list,
                total
            });
        })
        .catch(() => {
            _this.showErrorTips();
            reject();
        });
    });
}

/* 时区转换 */
export function dateTimeChange (data, orgCode, _this) {
    let obj = _this.$store.state.INT_TIME_ZONE.find((item) => item.code === orgCode);
    if (obj && obj.value) { 
        return moment(data).add(+obj.value, 'h').format('YYYY-MM-DD HH:mm:ss');
    } else {
        return moment(data).format('YYYY-MM-DD HH:mm:ss')
    }
}

/* 时区转换 */
export function queryIntTimeZone (orgId, callBack) {
    axios.post('/gscint/hw/finance/queryIntTimeZone', {
        orgId
    })
    .then((res) => {
        let data = res.data.data;
        callBack(data && +data.PARAMVALUEDESC || 0);
    });
}

/* 导出 */
export function exportExcel (button, _this, data, url) {
    _this.$set(button, 'loading', true);
    let paraJson = {
        ...data,
        description: undefined,
        vendorCode: _this.vendorCode,
        _language: _this.$i18n.locale === 'zh-CN' ? 'ZHS' : 'US'
    }
    window.open(`${url}?paraJson=${encodeURI(JSON.stringify(paraJson))}`);
    setTimeout(() => {
        _this.$set(button, 'loading', false);
    }, 2000);
}

/* 导出 */
export function exportExcel2(url, data, fileName, _this) {
    return axios({
        url,
        method: 'post',
        data,
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
    })
        .then((res) => {
            const reader = new FileReader();
            reader.readAsText = res;
            _this.downloadFile(res.data, `${fileName || reader.readAsText.headers['content-disposition'].split('filename=')[1]}`);
        })
        .catch((err) => {
            _this.showErrorTips();
        });
}

// export function exportLineExcel (loadingObj, data, url) {
//     loadingObj.loading = true;
//     let paraJson = {
//         ...data,
//         vendorCode: this.vendorCode
//     }
//     window.open(`${url}?paraJson=${encodeURI(JSON.stringify(paraJson))}`);
//     setTimeout(() => {
//         loadingObj.loading = false;
//     }, 2000);
// }